import { render, staticRenderFns } from "./TractFilter.vue?vue&type=template&id=2066ad04&"
import script from "./TractFilter.vue?vue&type=script&lang=js&"
export * from "./TractFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports